import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutSunya from "./components/AboutSunya";
import BrandPrinciples from "./components/BrandPrinciples";
import NewBooks2026 from "./components/NewBooks2026";
import PublishingPhilosophy from "./components/PublishingPhilosophy";
import ContentNotice from "./components/ContentNotice";
import SonboRelation from "./components/SonboRelation";
import FinalCTA from "./components/FinalCTA";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <AboutSunya />
        <BrandPrinciples />
        <NewBooks2026 />
        <PublishingPhilosophy />
        <ContentNotice />
        <SonboRelation />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}